<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'OrderCustomFieldsCreatePage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <div class="table-responsive">
            <table class="table table-fixed">
                <thead>
                    <tr>
                        <th width="50px"></th>
                        <th width="300px">{{ $t('table.titles.id') }}</th>
                        <th width="300px">{{ $t('labels.name') }}</th>
                        <th width="300px">{{ $t('labels.type') }}</th>
                        <th width="300px">{{ $t('labels.show_in_order') }}</th>
                    </tr>
                </thead>
                <tbody is="vue:VueDraggableNext" v-model="customFields" tag="tbody" handle=".drag-handle" :animation="150" :force-fallback="true" @start="onDragStart" @end="onDragEnd">
                    <tr v-for="customField in customFields" :key="customField.id">
                        <td>
                            <i class="icon-menu7 drag-handle text-muted cursor-pointer"></i>
                        </td>
                        <td>
                            <router-link :to="{
                                name: 'OrderCustomFieldsEditPage',
                                params: {
                                    customFieldUuid: customField.uuid
                                }
                            }">
                                {{ customField.id }}
                            </router-link>
                        </td>
                        <td>{{ customField.name }}</td>
                        <td>{{ $t(`enum.custom_field.type.${customField.type}`) }}</td>
                        <td>
                            <AppSwitch
                                :model-value="customField.show_in_order"
                                @update:model-value="updateShowInOrder(customField, $event)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AppSwitch from "../../../../components/new/form/switch/AppSwitch.vue";
import { VueDraggableNext } from "vue-draggable-next";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "OrderCustomFieldsIndexPage",
    components: {
        Card, VueDraggableNext, AppSwitch
    },
    data() {
        return {
            customFields: []
        }
    },
    methods: {
        onDragStart() {
            document.body.style.cursor = 'move';
            document.body.style.userSelect = 'none';
        },
        onDragEnd() {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            this.updatePriorityCustomFields();
        },
        updatePriorityCustomFields() {
            const uuids = this.customFields.map(customField => customField.uuid);
            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/custom-fields/priority`, { uuids });
        },
        updateShowInOrder(customField, showInOrder) {
            httpClient.put(`/projects/${this.$route.params.projectUuid}/crm/custom-fields/${customField.uuid}`, { show_in_order: showInOrder })
                .then(() => {
                    customField.show_in_order = showInOrder;
                })
        },
        fetchCustomFields() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`,
                {
                    orders: [
                        {
                            column: 'priority_order',
                            dir: 'asc'
                        }
                    ],
                    limit: 100
                }
            )
                .then(response => {
                    this.customFields = response.data.data;
                })
        }
    },
    mounted() {
        this.fetchCustomFields();
    }
}
</script>
